import React, { Component } from 'react';
import clsx from 'clsx';
import debounce from 'lodash/debounce';
import { Popover } from '@nextiva/next-ui-components';
import styles from './TextWithHint.scss';

class TextWithHint extends Component {
  state = {
    isOpen: false,
  };

  handleMouseEnter = debounce(() => {
    if (!this.el) {
      return;
    }

    this.setState({
      isOpen: this.el.offsetWidth < this.el.scrollWidth,
    });
  }, 300);

  closePopover = () => this.setState({ isOpen: false });

  handleMouseLeave = () => {
    this.closePopover();
    this.handleMouseEnter.cancel();
  };

  render() {
    const { text, className } = this.props;
    const TooltipComponent = this.state.isOpen
      ? Popover
      : ({ children }) => children;

    if (!text) return null;

    return (
      <div
        className={clsx(styles.textContainer, className)}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        ref={(el) => {
          this.el = el;
        }}
      >
        <TooltipComponent
          body={<div className={styles.hint}>{text}</div>}
          isOpen={this.state.isOpen}
          popper={{
            placement: 'bottom',
            modifiers: {
              offset: { offset: '0, 6' },
            },
          }}
          openOnClick={false}
          arrow={false}
        >
          {text}
        </TooltipComponent>
      </div>
    );
  }
}

export default TextWithHint;
